import { useState } from "react";
import { checkCode, sendCode } from "../api/apis";
import { useNavigate } from "react-router";
import { useApp } from "../Context";

export default function LoginPage() {
    const [phone, setPhone] = useState("");
    const [code, setCode] = useState("");
    const [codeSent, setCodeSent] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate()
    const {setAuth} = useApp()

    const handleClick = async () => {
        setError(null); // clear previous errors

        if (codeSent) {
            const response = await checkCode(phone, code);
            if (response.ok) {
                setAuth({phone, code})
                //localStorage.setItem("auth",JSON.stringify({phone, code}))
                navigate("..")
            } else {
                console.warn("Code check failed:", response.error);
                setError("Fel kod – försök igen.");
            }
        } else {
            const res = await sendCode(phone);
    
            if (res.ok) {
                setCodeSent(true);
            } else {
                console.warn("Failed to send code:", res.error);

                // Handle common error cases
                if (res.code === "USER_NOT_FOUND") {
                    setError("Ingen användare hittades med det numret.");
                } else if (res.code === "INVALID_BODY") {
                    setError("Ogiltigt telefonnummer – kontrollera formatet.");
                } else {
                    setError("Ett fel uppstod. Försök igen senare.");
                }
            }
        }
    };

    return (
        <>
        <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="card shadow p-4" style={{ width: "80%", maxWidth: "400px", marginBottom: "200px" }}>
                <h4 className="mb-3 text-center fw-bold">Logga in</h4>

                {error && (
                    <div className="alert alert-danger text-center py-2">
                        {error}
                    </div>
                )}
                
                <div className="mb-2 text-start">
                    <label className="form-label mb-0">Mobilnummer</label>
                    <input
                        type="tel"
                        className="form-control"
                        placeholder="ex. 07X-XXX XX XX"
                        value={phone}
                        onChange={(e) => {
                            setPhone(e.target.value)
                            if (error) setError(null)
                        }}
                    />
                </div>

                {codeSent && (
                    <div className="mb-2 text-start">
                        <label className="form-label mb-0">Engångskod</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="ex. XXXX"
                            value={code}
                            onChange={(e) => {
                                setCode(e.target.value)
                                if (error) setError(null)
                            }}
                        />
                    </div>
                )}

                <button
                    className="btn btn-warning fw-semibold w-100 mt-3"
                    onClick={handleClick}
                >
                    {codeSent ? "Verifiera kod" : "Skicka kod via SMS"}
                </button>
                {
                <button className="btn btn-outline-secondary mt-3" onClick={()=>{setCodeSent(true)}}>Demo</button>
            }
            </div>
            
        </div>
        </>
    );
}
